const configPulseChain = {
  mafiaAddress: "0xa27aDe5806Ded801b93499C6fA23cc8dC9AC55EA",
  pairAddress: "0x113bbdfea64b06aebe14a50e00c70149a32973ab",
  vaultAddress: "0x776F3D2d483580b12a2cD163bE40F649b2d1FF34",
  vault1Address: "0xCABDd520EeDC6736F4C057Cba275673d74766A6b",
  profileAddress: "0x7FB6A056877c1da14a63bFECdE95ebbFa854f07F",
  profileUnboxAddress: "0xE24C2629A9d898a3c00c7082EC261b2c36A9131F",
  // Founder-table contracts are currently deployed on BNB Chain only.
  ftsAddress: "0x2FA131c51E6c3567e994105192fbB4733b07D4CD",
  ftsMarketAddress: "0x9023e2ec4Ac7790e3F86Dc22CCC97eC961C3B973",
  ftsSubscriptionAddress: "0x07c5f56C599D82292a1d8E6eb5e48034674EDe99",
  ftsInitialSupply: 2_943,

  mafiaFamilyAddress: "0x3363cf983ae23AF2D95a81bA4A39C36084f8BEc4",
  familyBankAddress: "0xaD068Df1cedBf631A9D9B050eEBf1778E2d4A2ED",
  /** MafiaFamilyCashBank — in-game cash family bank (deposit / withdraw) */
  familyCashBankAddress: "0x5f9D683452626fd87C8d23c3b6d239d416d3Eb63",
  ogCrateAddress: "0x3325E42aA71188939216b669E8d431718e5bd790",
  crateMinterAddress: "0x7FE7220E6A8AAB508c60be9d48fEfacDbe6BC179",
  inventoryAddress: "0x2c60de22Ec20CcE72245311579c4aD9e5394Adc4",
  marketAddress: "0x321e27aaB7e6F5DE221AE3eAe63306345f3A465d",
  ogNFTAddress: "0xC647421A47dc793292E880bD77782c664BD6Af2a",
  ogPremiumAddress: "0xf0ae11A736b90987589ce64b1D77eBc328d0622F",

  gamebankAddress: "0x839340bDC0b0E4449b7e1dEBD0db7E93861Ed1D9",
  exchangeAddress: "0x11ee2732eD4C6BFe673e7b4BE15ece35D6a8cCD7",
  depositAddress: "0xC9565b4f23C301Cf9f158D72A842BA6a53B84590",
  vaultSplitterAddress: "0x5853EDBe3E619C73f9720ce4aF50F506340617B0",

  mapAddress: "0xE571Aa670EDeEBd88887eb5687576199652A714F",

  daoAddress: "0xD772D9f127b15d81c46582D49426d319044a541d",
  proposalAddress: "0x50ad97424d3e7Cf5F7D4B73b0F97AdE1f4e140eD",

  rouletteAddress: "0xD49Df542a9278464E7E18af52AB93D40D3430A9F",
  slotAddress: "0x52A929a1D43C18c6De571189D1c56c8574AA21a3",
  rankXpAddress: "0x74eADd7ebeeED638FD7c413134FA3D3433699D92",
  jailAddress: "0xDCD5E9c0b2b4E9Cb93677A258521D854b3A9f5A1",
  basicCrimeAddress: "0xf077d4d0508505c5a80249aFC10bc6Ead90E47F1",
  smuggleMarketAddress: "0x9bf722B3350832ae9023B7C9762227bE33943d09",
  carNickAddress: "0x2bf1EEaa4e1D7502AeF7f5beCCf64356eDb4a8c8",

  killSkillAddress: "0xdC45E5469A8B6D020473F69fEC91C0f0e83a3308",
  killInitiationContractEnabled: false,
  killInitiatorAddress: "",
  killRegistryAddress: "",
  mafiaRebirthAddress: "0x5D20a828693058C5370C6dCb54297f41eC3e2868",

  helperCreditAddress: "0x9D2417e5cB35abaae331b32fb262c75A258a0717",
  helperBotAddress: "0x6Ea05BaDD5B6e4226a49Af087eFd2A22c410e6cc",

  bulletTokenAddress: "0xe193484ef0f7880eb42c3bc34c1929f2e7680D64",
  inGameBulletAddress: "0x98f0d50b77BCcd657ecfa2E5C1E4915c6f4565B8",
  healthAddress: "0xA3b9a5E273a9199bbD64fFf81f369FEa0A3a0E1F",
  bulletFactoryAddress: "0x7770699325422632E76513823D84661D36AE8e6A",
  hospitalAddress: "0x222e69D7e1CA26D4Bbbd80637Dd49a8C07c3c8A1",

  bustOutAddress: "0xf404b3336f5D78406326e848c8bc14Cbf2566d0A",
  xpMarketAddress: "0xc5731c6C3627F4912B54A2c6e13A8BFaeD69A39C",

  raceXp: "0x6B454a53581E3b1e93553485210A2172e4897FD0",
  raceLobby: "0x10D0D93BD141a76F8cBcA1cd94CAf8081C5d0427",

  perkBoxMinter: "0xF3B4F7d0ec795B555e12BC70150dDb1081FdA403",
  perkBoxClaim: "0x05BE7743913dECe53D93E22120279f0630014743",
  perkOpener: "0xE3a3892fEC9bA9457fEE08Fe3d2E7b32bCeb33Ad",
  perkManager: "0xAe6311dF40FC6fE8fe9F06c7381E02eEa8B88c0F",

  jackpot: "0xeD548643332E019C97e3150736807839bf174dF9",
  lotteryHall: "0xfFBff4aFc8e0Ed6a3b609c714C72e767F7ed5CC4",
  shop: "0xd442356eF1c11f1B577c89542882c032E8DB82FE",
  training: "0x25d25524044A74eFe1Ff279abfe9708c69f5cbcE",
  equipment: "0x37edFc50908e194f05912EA0BC812Cd2f1Eb5bE4",

  swapRouter: "0xf89DFF55EE67F4247cd0D351e75080f07c1f4D2B",
  giCredit: "0xEDe999DDF33851F99e450468dE7251CcE96e2A72",
  playerSubscription: "0xC6409a0113cCF6c4194FBfD8C7409589465e15EC",
  giManager: "0xe327d64a24C1159aA5AF4df9171c5882CC9F10ff",

  weeklyMission: "0xCB8ab5f2A83F6Cd56d5aF97b3A6c942ab989fa25",
  storyMode: "0xaa4a6b620D869F05490A2DF6f43892d4664d2b7B",

  familyStakeShare: "0x781373e300B0A8bE65cC7365a86318157627e58C",
  rankStake: "0xcecf804016bd0cfDEE8F506EA273c6E5D74f6699",

  ocLobbyAddress: "0xE9680c72817477f9e51596bD39821C670790a66E",
  ocJoinAddress: "0xE79495F0982FCC3e884E5bCC2960D6d48439fCB6",
  ocExecutionAddress: "0x7783e026416cF3B43046f3C2D45eFFa582bA2e91",

  detectiveAgency: "0xB31B9f5a9f99871B30956B96CcDEC275C48D84F1",
  carCrusherAddress: "0x5D9D43f6890868C88315411fd7B012b4194C96Ab",
  safehouseAddress: "0x67336ec867c5631c08F1A536FAdF9DC489EeFf71",

  chainSymbolFull: "Pulse",
  chainSymbol: "PLS",
  chainName: "PulseChain",
  chainId: 369,
  chainIdHex: 0x171,
  blockTime: 3000,
  /** PulseChain block gas limit (no per-tx cap below this) */
  maxTxGas: 30_000_000,

  providerList: ["https://rpc.pulsechain.com"],

  explorerUrl: "https://otter.pulsechain.com/",

  nativePriceUrl:
    "https://api.coingecko.com/api/v3/simple/price?ids=pulsechain&vs_currencies=usd",
  mafiaPriceUrl: "https://api.dexscreener.com/latest/dex/pairs/pulsechain/",
  tradeUrl: "https://pulsex.mypinata.cloud/ipfs/bafybeiaq4jgcpz4hdzwid6letizdnhijlp6lu5ivcjcp5vbgpgf54jknn4/#/",

  domain: "pls.playmafia.io",
  mapDomain: "https://pls.playmafia.io/map-game",
  title: "PulseMafia",
  gitbookUrl: "https://mafiagame.gitbook.io/",

  serverEndpoint: "https://backendpls.playmafia.io",
  mockServerEndpoint: "http://localhost:5000",
  testServerEndpoint: "https://54q31jdb-3000.usw3.devtunnels.ms",

  newFirebaseConfig: {
    apiKey: "AIzaSyDCe5-P3COibgJSlCTQUITW3vKcrG9T15g",
    authDomain: "pls-mafia.firebaseapp.com",
    projectId: "pls-mafia",
    storageBucket: "pls-mafia.appspot.com",
    messagingSenderId: "512691599171",
    appId: "1:512691599171:web:a578623ab71affd42221f6",
    measurementId: "G-XLJ2BSVPDD",
  },

  storageBucket: "gs://pls-mafia.appspot.com",

  symbol: "$MAFIA",
  gtagId: "G-23N4S5NRXL",
};

export default configPulseChain;
